import i18n from '@/utils/i18n';
import React from 'react';
import { Animated } from 'react-native';
import {
  Avatar,
  createRestaurantAvatarProps,
  Icons,
  List,
  shadowStyle,
  XStack,
  YStack,
} from '@usepepper/sprout-kit-ui';
import { OrderEntryMobileConfidentialToggle } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/components/order-entry-mobile-confidential-toggle';
import { OrderEntryMobileHeaderPanelIconButton } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/components/order-entry-mobile-header-panel-icon-button';
import { OrderEntryMobileHeaderPanelListItem } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/components/order-entry-mobile-header-panel-list-item';

const SHEET_SHADOW = shadowStyle('sheet', 8);

interface OrderEntryMobileHeaderPanelContentsProps {
  contentOpacity: Animated.Value;
  details: React.ReactNode;
  onClose: () => void;
  onSelectRestaurant: () => void;
  restaurantName: string;
  restaurantUUID: string;
}

export const OrderEntryMobileHeaderPanelContents: React.FC<
  OrderEntryMobileHeaderPanelContentsProps
> = ({
  contentOpacity,
  details,
  onClose,
  onSelectRestaurant,
  restaurantName,
  restaurantUUID,
}) => (
  <YStack
    backgroundColor="$bgPrimaryDefault"
    borderBottomLeftRadius="$24"
    borderBottomRightRadius="$24"
    paddingBottom="$16"
    paddingHorizontal="$16"
    paddingTop="$8"
    style={SHEET_SHADOW}
  >
    <Animated.View style={{ opacity: contentOpacity }}>
      <XStack justifyContent="space-between" marginBottom="$8">
        <OrderEntryMobileConfidentialToggle />
        <OrderEntryMobileHeaderPanelIconButton
          accessibilityLabel={i18n.t(
            'sales_portal.order_entry.mobile_header.a11y.close',
          )}
          onPress={onClose}
        >
          <Icons.X color="$iconSecondary" size={18} />
        </OrderEntryMobileHeaderPanelIconButton>
      </XStack>
      <List>
        <OrderEntryMobileHeaderPanelListItem
          leading={
            <Avatar
              {...createRestaurantAvatarProps(restaurantName, restaurantUUID)}
              name={restaurantName}
              size="$xs"
            />
          }
          onPress={onSelectRestaurant}
          title={restaurantName}
        />
      </List>

      {details}
    </Animated.View>
  </YStack>
);
